import React from "react";
import "../styles/OurTeam.css";

const teamMembers = [
  {
    name: "Kamalanathan M",
    title: "Assistant Manager - HR",
    image: "/assets/team/kamala_1.png",
    linkedin: "https://www.linkedin.com/in/kamalanathanm/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B%2FE2Q%2BeKnQxizwVV6%2Bs5NiQ%3D%3D",
  },
  {
    name: "Keerthana K",
    title: "Senior - TA",
    image: "/assets/team/keerthana_1.png",
    linkedin: "https://linkedin.com/in/keerthana-k-2b9004250",
  },
  {
    name: "Sakthi V",
    title: "IT Recruiter",
    image: "/assets/team/shakthi_1.png",
    linkedin: "https://linkedin.com/in/sakthi-veerapandiyan-426072345",
  },
  {
    name: "Swetha K",
    title: "IT Recruiter",
    image: "/assets/team/swetha_1.png",
    linkedin: "https://linkedin.com/in/swetha-k-70b7a3275",
  },
  {
    name: "Devishree N",
    title: "IT Recruiter",
    image: "/assets/team/devishree_1.png",
    linkedin: "https://www.linkedin.com/in/devishree-nagan-01775b386",
  },
  {
    name: "Shreelakshmi",
    title: "Associate Business Development",
    image: "/assets/team/shreelakshmi_1.png",
    linkedin: "#",
  },
  {
    name: "Baranidharan M",
    title: "Software Engineer",
    image: "/assets/team/bharan_1.png",
    linkedin: "https://linkedin.com/in/baranidharan-murugesan-458209371",
  },
  {
    name: "Sanjay M",
    title: "UX/UI Designer",
    image: "/assets/team/san_1.png",
    linkedin: "https://linkedin.com/in/sanjaymagendramani",
  },
  {
    name: "Praveen S",
    title: "Junior Software Engineer",
    image: "/assets/team/praveen_1.png",
    linkedin: "https://linkedin.com/in/praveen-samiayya-242a27250",
  },
  {
    name: "Janarthan G",
    title: "Junior Software Engineer",
    image: "/assets/team/jana_1.png",
    linkedin: "https://www.linkedin.com/in/janarthan-g-988505281",
  },
  {
  name: "Hire For You",
  title: "Open Position",
  image: "",
  linkedin: "",
  isOpenPosition: true,
}
];

export default function OurTeam() {
  return (
    <section className="team-section">
      <h2 className="team-title">People &amp; Culture</h2>
      <p className="team-subtitle">
        A team culture built on understanding, innovation, and customization.
      </p>
      <div className="team-grid">
        {teamMembers.map((member, idx) =>
  member.isOpenPosition ? (
    <div className="team-card team-card--open" key={idx}>
      <div className="team-photo-wrapper team-photo-wrapper--open">
        <div className="team-photo-wrapper team-photo-wrapper--open">
  <div className="open-position-circle">
    <svg
      width="60"
      height="60"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="open-position-icon"
    >
      <circle
        cx="32"
        cy="22"
        r="8"
        stroke="#1D4ED8"
        strokeWidth="3"
      />

      <path
        d="M20 48V44C20 37.37 25.37 32 32 32C38.63 32 44 37.37 44 44V48H20Z"
        stroke="#1D4ED8"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  </div>
</div>
        
      </div>

      <div className="team-info">
        <span className="team-name">Hire For You</span>
        <span className="team-title-job open-position-label">
          
        </span>

        <a href="/careers" className="join-btn">
          Join Our Team
        </a>
      </div>
    </div>
  ) : (
    <div className="team-card" key={idx}>
      <div className="team-photo-wrapper">
        <img
          src={member.image}
          alt={member.name}
          className="team-photo"
        />

        {member.linkedin && (
          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-overlay"
            aria-label={`${member.name} on LinkedIn`}
          >
            <img
              src="/assets/icons/linkedin2.png"
              alt="LinkedIn"
            />
          </a>
        )}
      </div>

      <div className="team-info">
        <span className="team-name">{member.name}</span>
        <span className="team-title-job">{member.title}</span>
      </div>
    </div>
  )
)}
      </div>
    </section>
  );
}
